<template>
  <router-view />
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
import qbankConfig from './config/qbank.js';



export default defineComponent({
  name: "App",
  data: function () {
    return {
      firstRunData: '',
      IsDevAllowed: false,
      qbankConstants: qbankConfig.getConfig(),
      userBlocked: false,
      blockMessage: '',
      blockReason: '',
      violationType: null,
    }

  },
  computed: {
    // Reactive subscription URL - updates when firstRunData changes
    subscriptionUrl() {
      if (this.firstRunData && this.firstRunData.subscriptionUrl) {
        return this.firstRunData.subscriptionUrl;
      }
      // Fallback to subscription plans page
      const hostname = window.location.hostname;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://127.0.0.1:8000/subscription-plans/';
      }
      return window.location.origin + '/subscription-plans/';
    }
  },
  methods: {
    getQbankConstants() {
      return this.qbankConstants;
    },
    getUiConfig(key, defaultValue) {
      return qbankConfig.getUiConfig(key, defaultValue);
    },
    getUserID() {
      // @ts-expect-error
      // @ts-ignore
      //return parseInt(document.querySelector("#userID").value);
      return 1;
    },
    getAjaxURL() {
      // If apiURL is explicitly set in constants, use it
      if (this.qbankConstants.apiURL) {
        return this.qbankConstants.apiURL;
      }
      // Auto-detect based on current hostname
      const hostname = window.location.hostname;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://127.0.0.1:8000/frontend-qbank-api/vue-ajax.php';
      }
      // For any production domain, use relative path from current origin
      return window.location.origin + '/frontend-qbank-api/vue-ajax.php';
    },
    getLaravelApiURL() {
      // Laravel API base URL - always use relative path
      // In dev mode, Quasar devServer proxy forwards /api to Laravel backend
      // In production, same origin handles it
      return '/api';
    },
    getNonce() {
      // @ts-expect-error
      // @ts-ignore
      //return (document.querySelector("#ymp_ajax_nonce").value);
      return "";
    },
    getLoginURL() {
      // @ts-expect-error
      // @ts-ignore
      //return (document.querySelector("#ymp_ajax_nonce").value);
      return "https://yourmedpass.com/login";
    },
    getSubscriptionURL() {
      // Get subscription URL from API response (set by firstAppRun)
      if (this.firstRunData && this.firstRunData.subscriptionUrl) {
        return this.firstRunData.subscriptionUrl;
      }
      // Fallback to subscription plans page
      const hostname = window.location.hostname;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://127.0.0.1:8000/subscription-plans/';
      }
      return window.location.origin + '/subscription-plans/';
    },
    getWhatsAppPhone() {
      // Get WhatsApp phone from API response
      if (this.firstRunData && this.firstRunData.whatsapp_phone) {
        return this.firstRunData.whatsapp_phone;
      }
      return '962790495342'; // Fallback
    },
    getSupportEmail() {
      // Get support email from API response
      if (this.firstRunData && this.firstRunData.support_email) {
        return this.firstRunData.support_email;
      }
      return 'info@yourmedpass.com'; // Fallback
    },
    isDevAllowed() {
      const that = this;
      return that.firstRunData.qbank;
    },
     firstAppRun() {
      const that = this;

      // Use the new Laravel API endpoint
      const apiUrl = this.$root.getLaravelApiURL() + '/quiz-app/init';
      const config = {
        withCredentials: true, // Send session cookie for auth
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      };

      const data = {
        qbank_source: this.qbankConstants.qbank_source || 1
      };

      axios.post(apiUrl, data, config).then(response => {
        console.log('firstRun response:', response.data);
        that.firstRunData = response.data;
      }).catch(error => {
        console.error('firstRun error:', error);
      });
    }
  },
  created() {
    // Setup axios interceptor to catch blocked user responses
    const that = this;
    axios.interceptors.response.use(
      response => response,
      error => {
        // Check if error response indicates user is blocked
        if (error.response && error.response.status === 403 && error.response.data?.user_blocked) {
          console.log('[App] User blocked detected via API response');
          that.userBlocked = true;
          that.blockMessage = error.response.data.message || 'تم إيقاف حسابك.';
          that.blockReason = error.response.data.block_reason || 'unknown';
          that.violationType = error.response.data.violation_type || null;

          // Emit event for layouts to handle
          window.dispatchEvent(new CustomEvent('user-blocked', {
            detail: {
              message: that.blockMessage,
              reason: that.blockReason,
              violationType: that.violationType
            }
          }));
        }
        return Promise.reject(error);
      }
    );
  },
});
</script>
